import { useRef, useContext } from 'react';
import { Link } from 'react-router-dom';
import SidebarContext from '../context/SidebarContext';
import AuthContext from '../context/AuthProvider';
import ProfilePicture from '../static/img/profile.jpg';

const Topbar = () => {
    const { collapsed } = useContext(SidebarContext);
    const { auth, logout } = useContext(AuthContext);
    const searchInputRef = useRef(null);
  
    return (
      <div className={`topbar ${collapsed ? 'collapsed' : ''}`}>
        <form className="search-container">
          <input type="text" placeholder="Search Client..." ref={searchInputRef} />
          <button className="search-btn" type="submit">
            <i className="fa fa-search"></i>
          </button>
        </form>
        <div className="top-right">
          <p>
            {auth.amnFirstName} {auth.amnLastName}
          </p>
          <img src={ProfilePicture} alt="" />
          <div className="icons">
            <div>
              <i className="fas fa-bell"></i>
            </div>
            <div className="logout-icon">
              <Link to="/">
                <i className="fas fa-sign-out-alt" onClick={logout}></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  };  

export default Topbar;